import styled from 'styled-components';
import * as Material from '@material-ui/core';
import * as Parent from '../styles';


export const DeclaracaoSubtitle = styled.span`
    font-weight: bold;
    padding-right: 10px;
    margin: 0px;
    width: 100%;
`;

export const LinhaSubtitle = styled.div`
    margin-bottom: 20px;
`;

export const ResultTitle = styled.p`
font-weight: lighter;  
`;

export const ModalBody = styled.div`
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    width: 1000px;
    max-width: 90%;
    background-color: white;
    -webkit-box-shadow: 5px 5px 15px 5px #000000; 
    box-shadow: 5px 5px 15px 5px #000000;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    padding: min(20px, 4%) min(85px, 4%);
`;
export const SelectMenu = styled.select`
   color: #34bfb1;
   border: #34bfb1;
`;
export const ModalCloseButton = styled(Material.Button)`
    position: absolute;
    top: 27px;
    right:  min(27px, 5%);;
    -webkit-border-radius: 30px;
    -moz-border-radius: 30px;
    border-radius: 30px;
    height: 65px;
    width: 65px;
`;


export const ModalSessionTitle = styled(Parent.SessionTitle)`
    margin-top: 30px;
`

export const BoxButtonModal = styled.div`
    width: min(400px, 100%);
`;